import { render, staticRenderFns } from "./VineyardResourceGraphs.vue?vue&type=template&id=af8278c2&scoped=true&"
import script from "./VineyardResourceGraphs.vue?vue&type=script&lang=js&"
export * from "./VineyardResourceGraphs.vue?vue&type=script&lang=js&"
import style0 from "./VineyardResourceGraphs.vue?vue&type=style&index=0&id=af8278c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8278c2",
  null
  
)

export default component.exports